import React from "react";
import { Accordion } from "flowbite-react";

const FAQ: React.FC = () => {
  return (
    <div className="rounded-xl border border-gray-200 dark:border-neutral-700 bg-white dark:bg-neutral-800 p-4">
      <h4 className="font-semibold text-gray-900 dark:text-white mb-2">Frequently Asked Questions</h4>
      <Accordion collapseAll>
        <Accordion.Panel>
          <Accordion.Title>How do I connect my ad accounts?</Accordion.Title>
          <Accordion.Content>
            <p className="text-sm text-gray-600 dark:text-gray-300">Go to Integrations and follow the guided flow for each network.</p>
          </Accordion.Content>
        </Accordion.Panel>
        <Accordion.Panel>
          <Accordion.Title>Why don’t I see recent data?</Accordion.Title>
          <Accordion.Content>
            <p className="text-sm text-gray-600 dark:text-gray-300">Data syncs periodically. Check integration status and refresh.</p>
          </Accordion.Content>
        </Accordion.Panel>
        <Accordion.Panel>
          <Accordion.Title>How can I invite team members?</Accordion.Title>
          <Accordion.Content>
            <p className="text-sm text-gray-600 dark:text-gray-300">Navigate to Settings → Team and send an invite by email.</p>
          </Accordion.Content>
        </Accordion.Panel>
        <Accordion.Panel>
          <Accordion.Title>Where do I change my password or profile?</Accordion.Title>
          <Accordion.Content>
            <p className="text-sm text-gray-600 dark:text-gray-300">Go to Settings → Account to update personal details and password.</p>
          </Accordion.Content>
        </Accordion.Panel>
      </Accordion>
    </div>
  );
};

export default FAQ;
